import React from 'react'
import "../styles/corporate.css"
import Hero from '../components/corporate/CorporateHero'
import Navbar from '../components/common/Navbar'
import CorporateIntro from '../components/corporate/CorporateIntro'
import CorporateCapabilities from '../components/corporate/CorporateCapabilities'
import CorporateWhy from '../components/corporate/CorporateWhy'
import CorporateIndustries from '../components/corporate/CorporateIndustries'
import CorporateContact from '../components/corporate/CorporateContact'

const Corporate = () => {
  return (
    <div className='corporate_page'>
    <Navbar />
    <Hero />
    <CorporateIntro />
    <CorporateCapabilities />
    {/* <CorporatePhilosophy /> */}
    <CorporateWhy />
    <CorporateIndustries />
    <CorporateContact />
    </div>
  )
}

export default Corporate
